import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Breadcrumb } from "react-bootstrap";
import "./AppBreadcrumb.scss";

const AppBreadcrumb = () => {
  const location = useLocation();

  // array for breadcrumbs , removing first element of array by slice and then 
  // converting first letter of each string to uppercase, 
  // splitting on the basis of dash sign

  const breadCrumbArray = location.pathname
    .split("/")
    .slice(1)
    .map(
      (state) =>
        state.charAt(0).toUpperCase() +
        state
          .split("-")
          .map((state) => state.charAt(0).toUpperCase() + state.slice(1))
          .join(" ")
          .slice(1)
    );

  return (
    <Container fluid="lg">
      <div className="Breadcrumb_Holder">
        <Breadcrumb as="div">
          <Breadcrumb.Item as="li">Home</Breadcrumb.Item>
          {breadCrumbArray.map((state) => (
            <Breadcrumb.Item as="li" key={state}>
              {state}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>
    </Container>
  );
};

export default React.memo(AppBreadcrumb);
